import { render, staticRenderFns } from "./promotionGoodsCell.vue?vue&type=template&id=1de5e47c&scoped=true"
import script from "./promotionGoodsCell.vue?vue&type=script&lang=js"
export * from "./promotionGoodsCell.vue?vue&type=script&lang=js"
import style0 from "./promotionGoodsCell.vue?vue&type=style&index=0&id=1de5e47c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de5e47c",
  null
  
)

export default component.exports